module.exports = __webpack_public_path__ + "img/2.8dd7379a.jpeg";